module.exports = __webpack_public_path__ + "static/media/edit_box.ccc32836.svg";